module.exports = __webpack_public_path__ + "img/wallet_02_non_3.bcc7287f.png";